import { useQuery } from '@hooks/reactQuery';

import { getCrowdCells } from '@api/manageCrowdCells';

import { extractQueryParams } from '@utils/common';

import { IGetCrowdCellsDTO } from '@interfaces/crowdcell/dto/crowdCellsDTO';

import { CROWDCELLS } from '@constants/queryKeys';

export const useQueryCrowdCells = (params?: IGetCrowdCellsDTO) => {
	const {
		data,
		isLoading: isLoadingCrowdCells,
		isFetching: isFetchingCrowdCells,
	} = useQuery({
		queryKey: [
			CROWDCELLS,
			params,
		],
		queryFn: extractQueryParams(getCrowdCells),
		refetchOnWindowFocus: false,
	});

	return {
		crowdCells: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingCrowdCells: isLoadingCrowdCells || isFetchingCrowdCells,
	};
};
